import React, { Component } from "react";
import DatosSocio from "../../generico/DatosSocio";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowRight, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
//// componentes reutilizables
import DataTable from 'react-data-table-component';

export default class TarjetaPaso3 extends Component {
  constructor(props) {
    super(props);    
    this.state = this.getInitialState();    
  }

  getInitialState = () => ({
    datosCuenta:[]
  })  

  componentDidMount() {
  //  this.getDatosCuenta()
  }

  getColumn() {
    return [
    {
      name: "concepto",
      selector: row => row.concepto,
    },
    {
      name: "valor",
      selector: row => row.valor,
    }]
  }

  getDatosCuenta() {
    var respuesta = [
      {concepto: "Total a Pagar:", valor: this.props.importe + " GS"}
    ];

    //this.setState({ datosCuenta: respuesta });
    return respuesta;
  }



  render() {
    var elementos=[]
    if (this.props.currentStep === 3) {
      elementos = this.getDatosCuenta()
      //console.log(this.props.tarjeta)
    }
      return (
            <div>
              <div className="row">
                <div className="steps clearfix">
                  <ul role="tablist">
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text current">
                            Selección de Tarjeta
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text">
                            Datos de Pago
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="current">
                      <span>
                        <div className="title">
                          <span className="title_text">
                            Datos de Verificación
                          </span>
                        </div>
                      </span>
                    </li>
                    <li role="tab" className="disabled">
                      <span>
                        <div className="title">
                          <span className="title_text">Confirmación</span>
                        </div>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>


              <div className="row justify-content-md-center">
                <div className="col-md-8">
                <div className="form-group">
                <DatosSocio />
                  </div> 
                  <div className="form-group">
                    <label className="input-label">Tarjeta:</label><br/> 
                    <label className="input-label-bold">{this.props.tarjeta} - Tipo {this.props.tipo} - Deuda: {this.props.deuda} GS.</label>
                  </div>  
                  <div className="form-group">
                    <label className="input-label">Cuenta Origen (a debitar):</label><br/> 
                    <label className="input-label-bold">{this.props.debito}</label>                    
                  </div> 
                  <div className="form-group">
                    <label className="input-label">Total a Pagar:</label><br/> 
                    <label className="input-label-bold">{this.props.importe +" "+ this.props.moneda}</label>                    
                  </div>
                </div>
              </div>  
              {/*
              <div className="row justify-content-md-center">
                <div className="col-md-8">
                  <div className="row"> 
                    <div className="table-responsive">
                      <DataTable
                        noHeader={true}
                        columns={this.getColumn()}
                        data={elementos}
                        dense={true}
                        noDataComponent="ingrese un número de contrato para mostrar la información"
                        responsive={true}
                        noTableHead={true}/>                               
                    </div>                          
                  </div>   
                </div>                       
              </div> */} 
              
              <hr/>

              <div className="row">
                <div className="col-lg-8 col-md-6">
                    <label className="input-label-bold" style={{marginTop:10}}>
                      Esta seguro que desea CONFIRMAR la operación?<br/>
                    </label> 
                </div> 
                <div className="col-lg-2 col-md-3 btn-consulta">              
                    <button className="btn btn-cu-quintary"
                      onClick={this.props.previousStep}>
                     <FontAwesomeIcon  icon={faArrowLeft}/> Volver
                    </button>
                </div>  
                <div className="col-lg-2 col-md-3">
                <button className="btn btn-cu-primary" ref={btn => { this.btn = btn; }}
                     onClick={this.props.paso3Next}> Confirmar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                    <button
                      hidden
                      ref={(a) => (this.nextStep = a)}
                      className="btn btn-cu-primary"
                      onClick={this.props.nextStep}>
                    </button>
                </div>
              </div> 
          </div>  
      );
  }
}